<template>
    <div class="column content-box">
      <woot-button
        color-scheme="success"
        class-names="button--fixed-top"
        icon="add-circle"
        @click="openAddPopup()"
      >
        {{ $t('CADENCIAS.HEADER_BTN_TXT') }}
      </woot-button>
      <div class="row">
        <div class="small-8 columns with-right-space">
          <div
            v-if="!uiFlags.isFetching && !records.length"
            class="cadencias__empty-state"
          >
            <p class="no-items-error-message">
              <img class="no-cadencia" src="/assets/images/dashboard/cadencia/404.png" alt="no-cadencia"/>
              {{ $t('CADENCIAS.LIST.404') }}
            </p>
          </div>
          <woot-loading-state
            v-if="uiFlags.isFetching"
            :message="$t('CADENCIAS.LOADING')"
          />
          <table aria-describedby="table" v-if="!uiFlags.isFetching && records.length" class="woot-table">
            <thead>
              <th
                v-for="thHeader in $t('CADENCIAS.LIST.TABLE_HEADER')"
                :key="thHeader"
              >
                {{ thHeader }}
              </th>
            </thead>
            <tbody>
              <cadencias-table-row
                v-for="(cadencia, index) in records"
                :key="cadencia.id"
                :index="index"
                :cadencia="cadencia"
                @edit="openEditPopup"
                @delete="openDeletePopup"
              />
            </tbody>
          </table>
        </div>
        <div class="small-4 columns">
          <span v-dompurify-html="$t('CADENCIAS.SIDEBAR_TXT')" />
        </div>
      </div>
      <!-- Add Agent -->
      <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
        <add-cadencia :on-close="hideAddPopup" />
      </woot-modal>
      <!-- Edit Agent -->
      <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
        <edit-cadencia
          v-if="showEditPopup"
          :id="selectedCadencia.id"
          :value="selectedCadencia"
          :on-close="hideEditPopup"
        />
      </woot-modal>
      <!-- Delete Agent -->
      <woot-delete-modal
        :show.sync="showDeleteConfirmationPopup"
        :on-close="closeDeletePopup"
        :on-confirm="confirmDeletion"
        :title="$t('LABEL_MGMT.DELETE.CONFIRM.TITLE')"
        :message="$t('CADENCIAS.DELETE.CONFIRMATION')"
        :message-value="deleteMessage"
        :confirm-text="$t('CADENCIAS.DELETE.CONFIRM_YES')"
        :reject-text="$t('CADENCIAS.DELETE.CONFIRM_NO')"
      />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import AddCadencia from './NewCadencia';
import EditCadencia from './EditCadencia';
import CadenciasTableRow from './CadenciaRow';

export default {
    components: {
        AddCadencia,
        EditCadencia,
        CadenciasTableRow,
    },
    mixins: [alertMixin],
    data() {
        return {
            showAddPopup: false,
            showEditPopup: false,
            showDeleteConfirmationPopup: false,
            selectedCadencia: {},
            loading: {},
        }
    },
    computed: {
        ...mapGetters({
            records: ['cadencias/getCadencias'],
            uiFlags: 'cadencias/getUIFlags',
        }),
        deleteMessage() {
            return ` ${this.selectedCadencia.name}?`;
        },
    },
    mounted() {
        this.$store.dispatch('cadencias/get');
    },
    methods: {
      openAddPopup() {
        this.showAddPopup = true;
      },
      hideAddPopup() {
        this.showAddPopup = false;
      },
      openDeletePopup(cadencia) {
          this.showDeleteConfirmationPopup = true;
          this.selectedCadencia = cadencia;
      },
      closeDeletePopup() {
          this.showDeleteConfirmationPopup = false;
      },
      openEditPopup(cadencia) {
        this.showEditPopup = true;
        this.selectedCadencia = cadencia;
      },
      hideEditPopup() {
        this.showEditPopup = false;
      },
      confirmDeletion() {
          this.loading[this.selectedCadencia.id] = true;
          this.deleteCadencia(this.selectedCadencia.id);
          this.closeDeletePopup();
      },
      async deleteCadencia(id) {
          try {
              await this.$store.dispatch('cadencias/delete', id);
              this.showAlert(this.$t('CADENCIAS.DELETE.API.SUCCESS_MESSAGE'));
              this.loading[this.selectedCadencia.id] = false;
          } catch (error) {
              this.showAlert(this.$t('CADENCIAS.DELETE.API.ERROR_MESSAGE'));
          }
      },
    },
}
</script>

<style lang="scss">
.no-cadencia {
  width: 35vh;
  height: 25vh;
  max-width: 100% !important;
}
</style>